import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ShieldAlert, ArrowLeft } from "lucide-react";

export default function AdminLogin({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { password });
      onSuccess(data.token);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Password salah");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-theme flex items-center justify-center p-4 sm:p-8">
      <div className="w-full max-w-md">
        <button
          data-testid="admin-back-link"
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-6 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Kembali
        </button>

        <div className="admin-card p-8">
          <div className="flex items-center gap-3 mb-1">
            <div className="w-10 h-10 rounded-md bg-slate-900 flex items-center justify-center">
              <ShieldAlert className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-semibold text-slate-900">Admin Control Room</h1>
              <p className="text-xs text-slate-500 mono">Rigged Slot Simulation</p>
            </div>
          </div>

          <div className="mt-6 mb-6 h-px bg-slate-200" />

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium uppercase tracking-wider text-slate-500 mb-1.5">
                Password Admin
              </label>
              <Input
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Masukkan password"
                autoFocus
                disabled={loading}
                className="h-11"
              />
            </div>

            <Button
              type="submit"
              data-testid="admin-login-button"
              disabled={loading}
              className="w-full h-11 bg-slate-900 hover:bg-slate-800 text-white"
            >
              {loading ? "Memverifikasi..." : "Masuk"}
            </Button>
          </form>

          <div className="mt-6 p-3 bg-amber-50 border border-amber-200 rounded-md">
            <p className="text-xs text-amber-900 leading-relaxed">
              <span className="font-semibold">Hanya untuk fasilitator pelatihan.</span>{" "}
              Dari sini Anda bisa mengatur siapa yang menang. Inilah cara kerja sebenarnya
              di balik UI judi online.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
